module.exports = __webpack_public_path__ + "media/images/lb/488-82e84063d860b6fcfa3a1f68cd07c981.svg";